import { createSelector } from '@reduxjs/toolkit'
import { CheckoutConfigSlice } from './types'
import { RootState } from 'lib/core/data/reducer'

export interface CheckoutConfig {
  payment: Record<string, Record<string, any>>
}

export const getCheckoutConfig = (cartId?: string) => createSelector(
  (state: RootState): CheckoutConfigSlice => state.quote.checkoutConfig[cartId ?? ''],
  slice => {
    if (!slice) {
      return
    }

    const { isFetching, isSuccess, isFailure, data } = slice
    const payment = data?.payment ?? []

    const config: CheckoutConfig = {
      payment: {}
    }

    payment.forEach((item: any) => {
      const {
        code,
        payment_information: paymentInfo
      } = item

      config.payment[code] = JSON.parse(paymentInfo)
    })

    return {
      isFetching,
      isSuccess,
      isFailure,
      data: config
    }
  }
)
